module.exports = __webpack_public_path__ + "static/img/nz.3241e927.svg";